import { Tabs } from 'antd'
import React from 'react'
import { t } from 'i18next'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'
import dayjs from 'dayjs'
import SlotCards from './SlotCards'
import SlotList from './SlotList'
import Title from 'antd/es/typography/Title'
import { Color } from '../../Common/Color'

export default function SlotsTab ({ slots }) {
  const patientSlots = slots.filter(slot => slot.type === 'PatientSlot')
  const cleaningSlots = slots.filter(slot => slot.type === 'CleaningSlot')
  const maintenanceSlots = slots.filter(slot => slot.type === 'MaintenanceSlot')
  const screens = useBreakpoint()

  const ongoingSlot = (slot) => (
    ['clean_in_progress', 'late', 'in_progress', 'person_left'].includes(slot.state)
  )

  const nearSlot = (slot) => (
    slot.state === 'waiting' && dayjs(slot.begin_date) <= dayjs().add(1, 'hour')
  )

  const nextSlot = (slot) => (
    slot.state === 'waiting' && dayjs(slot.begin_date) > dayjs().add(1, 'hour')
  )

  const doneSlot = (slot) => (
    slot.state === 'done'
  )

  const canceledSlot = (slot) => (
    slot.state === 'auto_cancel' || slot.state === 'cancel'
  )

  const currentSlotTab = (slots) => {
    return displayedSlots(slots.filter((slot) => ongoingSlot(slot) || nearSlot(slot)))
  }

  const nextSlotsTab = (slots) => {
    return displayedSlots(slots.filter((slot) => nextSlot(slot)))
  }

  const doneSlotsTab = (slots) => {
    return displayedSlots(slots.filter((slot) => doneSlot(slot)))
  }

  const canceledSlotsTab = (slots) => {
    return displayedSlots(slots.filter((slot) => canceledSlot(slot)))
  }

  const allSlots = (slots) => {
    return displayedSlots(slots)
  }

  const displayedSlots = (slots) => {
    return (
      <>
        <Title level={4} style={{ marginTop: '0' }} >{`${slots.length} RDV`}</Title>
        { screens.xs && <SlotCards slots={slots} /> }
        { !screens.xs && <SlotList filteredSlots={slots} /> }
      </>
    )
  }

  const subTab = (slots) => (
    <Tabs
      tabPlacement='left'
      defaultActiveKey='current'
      style={screens.xs ? { '--ant-tabs-vertical-item-padding': '8px 10px' } : {}}
      items={[
        {
          label: t('Admin.SlotsPage.tab.currentSlots'),
          key: 'current',
          children: currentSlotTab(slots)
        },
        {
          label: t('Admin.SlotsPage.tab.nextSlots'),
          key: 'next',
          children: nextSlotsTab(slots)
        },
        {
          label: t('Admin.SlotsPage.tab.doneSlots'),
          key: 'done',
          children: doneSlotsTab(slots)
        },
        {
          label: t('Admin.SlotsPage.tab.canceledSlots'),
          key: 'canceled',
          children: canceledSlotsTab(slots)
        },
        {
          label: t('Admin.SlotsPage.tab.allSlots'),
          key: 'allSlots',
          children: allSlots(slots)
        }
      ]}
    />
  )

  return (
    <Tabs
      type='card'
      classNames={{ item: 'custom-tab-header' }}
      style={{ '--backgroundColor': Color.primary }}
      styles={{ root: { marginTop: '1em', backgroundColor: 'white' }, content: { padding: '0em 1em 1em 0em' } }}
      defaultActiveKey='all'
      items={[
        {
          label: t('Admin.SlotsPage.tab.allSlots'),
          key: 'all',
          children: subTab(slots)
        },
        {
          label: t('Admin.SlotsPage.tab.patientSlots'),
          key: 'patient',
          children: subTab(patientSlots)
        },
        {
          label: t('Admin.SlotsPage.tab.cleaningSlots'),
          key: 'cleaning',
          children: subTab(cleaningSlots)
        },
        {
          label: t('Admin.SlotsPage.tab.maintenanceSlots'),
          key: 'maintenance',
          children: subTab(maintenanceSlots)
        }
      ]}
    />
  )
}
